import { css } from '@emotion/react'
import { ArticleShareLinksItem } from './ArticleShareLinks.styled'
import { Icon } from 'components/icon'
import { Stack } from 'components/Stack'

import { Caption } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import { BREAKPOINTS } from 'utils/styled'

export function ArticleShareLinks(props: { path?: string; className?: string }) {
  const { t } = useTranslation()
  const [origin, setOrigin] = useState<string>()

  useEffect(() => {
    if (window.location.origin) {
      setOrigin(window.location.origin)
    }
  }, [])

  if (!props.path || !origin) return null

  const finalUrl = [origin, props.path].join('')
  return (
    <section className={props.className}>
      <Stack orientation="horizontal" space={36} css={{ alignItems: 'center' }}>
        <Caption
          css={css`
            @media ${BREAKPOINTS.MD.max} {
              flex-basis: 100%;
            }
          `}
        >
          {t('common.share')}
        </Caption>
        <ArticleShareLinksItem
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(finalUrl)}`}
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="Facebook" />
        </ArticleShareLinksItem>
        <ArticleShareLinksItem
          href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(finalUrl)}`}
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="Twitter" />
        </ArticleShareLinksItem>
        <ArticleShareLinksItem
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            finalUrl
          )}`}
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="LinkedIn" />
        </ArticleShareLinksItem>
      </Stack>
    </section>
  )
}
